// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jbOA","colBig":"styles_colBig__3Bmai","colSmall":"styles_colSmall__3w2So"};